import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import projectsRouter from "@/modules/projectListModule/router";
import projectInfoRouter from "@/modules/router";
import authRouter from "@/modules/auth/router";
import proposalsRouter from "@/modules/proposalsModule/router";
import store from '@/store';
const routes: Array<RouteRecordRaw> = [

  {
    path: '/auth',
    ...authRouter
  },
  {
    path: '/proposals',
    ...proposalsRouter
  },
  {
    path: '/projects',
    ...projectsRouter
  },
  {
    path: '/project',
    ...projectInfoRouter
  },
  {
    // Redirige cualquier ruta que no exista a la página de autenticación
    path: '/:pathMatch(.*)*',
    redirect: '/auth',
  },
  
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  // console.log("Auth guard");
  localStorage.setItem("fromPath", to.path)
  const userType = store.getters["auth/getUserType"]
  if(to.meta.requiresAuth){
    // Si el usuario no esta logueado, redirigimos al login
    if(userType === 0){
      //console.log("No hay usuario logueado");
      next('/auth')
      return;
    }
    // El usuario de tipo 4 no puede acceder a /projects, redirigimos a /proposals
    if (to.path === '/projects' && userType === 4) {
      next('/proposals')
      return;
    }
    // Si el usuario está logeado pero no tiene permisos, se cancela la navegación
    if(Array.isArray(to.meta.allowedUserTypes)){
      if(!to.meta.allowedUserTypes.includes(userType)){
        console.log("Permisos insuficientes");
        next(false);
        return;
      }
    }
  } 
  // Si el usuario no puede ir a la ruta /projects, comprobar su usuario y redirigir donde corresponda
  else if (to.meta.requiresUnauth && userType !== 0){
      next('/projects')
      return;
  }
  next();
});

export default router
